import { useState } from "react";
import { toast } from "sonner";
import { CalendarBlank, Clock, User, WhatsappLogo } from "@phosphor-icons/react";
import { formatPrice, formatDateBR } from "./format";
import { useLocale } from "@/i18n";

export { formatDateBR };

export default function DetailsStep({ service, date, time, submitting, onSubmit, professional }) {
  const { t, locale } = useLocale();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (name.trim().length < 2) return toast.warning(t("enter_name"));
    if (phone.replace(/\D/g, "").length < 8) return toast.warning(t("enter_wa"));
    onSubmit(name, phone);
  };

  return (
    <section data-testid="details-step">
      <p className="text-xs uppercase tracking-[0.2em] font-semibold text-amber-500">{t("step3")}</p>
      <h2 className="text-2xl font-bold tracking-tight text-zinc-100 mt-1">{t("your_data")}</h2>
      <p className="text-sm text-zinc-500 mt-1">{t("no_account_needed")}</p>

      <div className="mt-5 bg-zinc-900 border border-zinc-800 rounded-xl p-4 space-y-2" data-testid="booking-summary">
        <p className="font-bold text-zinc-100">{service.name}</p>
        <p className="flex items-center gap-2 text-sm text-zinc-400">
          <CalendarBlank size={15} className="text-amber-500" weight="duotone" />
          <span>{formatDateBR(date, locale)}</span>
        </p>
        <p className="flex items-center gap-2 text-sm text-zinc-400">
          <Clock size={15} className="text-amber-500" weight="duotone" />
          {time} · {service.duration_min} min · {formatPrice(service.price, locale)}
        </p>
        {professional && (
          <p className="flex items-center gap-2 text-sm text-zinc-400" data-testid="summary-professional">
            <User size={15} className="text-amber-500" weight="duotone" />
            {professional.name}
          </p>
        )}
      </div>

      <form id="booking-details-form" onSubmit={handleSubmit} className="mt-6 space-y-4" data-testid="details-form">
        <div>
          <label htmlFor="client-name" className="text-sm font-semibold text-zinc-300 flex items-center gap-2">
            <User size={15} className="text-amber-500" weight="duotone" /> {t("name_label")}
          </label>
          <input
            id="client-name"
            data-testid="name-input"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t("name_ph")}
            autoComplete="name"
            className="mt-2 w-full h-12 px-4 rounded-lg bg-zinc-900 border border-zinc-800 text-zinc-100 placeholder:text-zinc-600 focus:border-amber-500 focus:ring-1 focus:ring-amber-500 focus:outline-none transition-colors"
          />
        </div>
        <div>
          <label htmlFor="client-phone" className="text-sm font-semibold text-zinc-300 flex items-center gap-2">
            <WhatsappLogo size={15} className="text-amber-500" weight="duotone" /> WhatsApp
          </label>
          <input
            id="client-phone"
            data-testid="phone-input"
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder={t("wa_ph")}
            autoComplete="tel"
            className="mt-2 w-full h-12 px-4 rounded-lg bg-zinc-900 border border-zinc-800 text-zinc-100 placeholder:text-zinc-600 focus:border-amber-500 focus:ring-1 focus:ring-amber-500 focus:outline-none transition-colors"
          />
          <p className="text-xs text-zinc-500 mt-2">{t("client_wa_note")}</p>
        </div>
      </form>
    </section>
  );
}
